/* jshint esversion: 6 */
/* jshint esversion: 8 */
/* jshint ignore:start */
import React, { useContext, useEffect, useRef, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import { showToast } from '../../showTost';
import { useNavigate } from 'react-router-dom';
import emptyimg from "../../assets/Image/emptyOrder.png";
import { useTranslation } from 'react-i18next';
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
import ImageLoad from '../ImageLoad';
import { LuChevronRight, LuCalendar, LuPhoneCall } from 'react-icons/lu';
import { IoChevronBackOutline, IoCloseSharp } from 'react-icons/io5';

const BookingPackage = () => {

  const { t } = useTranslation();
  const { ApiBaseUrl, ImgBaseUrl } = useContext(MyContext);

  const [currentBooking, setCurrentBooking] = useState([]);
  const [pastBooking, setPastBooking] = useState([]);
  const [loading, setLoading] = useState(true);
  const [cancelReasonList, setCancelReasonList] = useState([]);
  const [isCancelBox, setIsCancelBox] = useState("");
  const [selectReason, setSelectReason] = useState();
  const [otherReason, setOtherReason] = useState();
  const [deviceCheck, setDeviceCheck] = useState(false);
  const [page, setPage] = useState(1);
  const [totallength, setTotalLength] = useState(0);

  const selectBtnref = useRef(0);
  const hasReachedBottom = useRef(false);
  const NoMoreDataRef = useRef(true);

  const Navigate = useNavigate();

  const site_currency = secureLocalStorage.getItem("currency");
  const currency = site_currency ? site_currency : "$";
  const Userid = secureLocalStorage.getItem("Userid");

  useEffect(() => {
    HandlefetchPandingData(1);
    axios.get(`${ApiBaseUrl}/customer/appint_cancel_list`)
      .then((res) => {
        // console.log("appint_cancel_list", res);
        setCancelReasonList(res.data.cancel_reason);
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  const HandlefetchPandingData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/lab_booking_pending_list`, { id: Userid, page })
        .then((res) => {
          // console.log("lab_booking_pending_list", res);
          const { ResponseCode, lab_pending_list } = res.data;
          if (ResponseCode === 200) {
            if (lab_pending_list.length === 0 || totallength > lab_pending_list.length) NoMoreDataRef.current = false;
            if (page === 1) {
              setCurrentBooking(lab_pending_list);
              setTotalLength(lab_pending_list.length);
            } else {
              setCurrentBooking(prev => [...prev, ...lab_pending_list]);
            }
            setLoading(false);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandlefetchCompleteData = (page) => {
    if (Userid) {
      axios.post(`${ApiBaseUrl}/customer/lab_booking_complete_list`, { id: Userid, page })
        .then((res) => {
          // console.log("lab_booking_complete_list", res);
          const { ResponseCode, lab_complete_list } = res.data;
          if (ResponseCode === 200) {
            if (lab_complete_list.length === 0 || totallength > lab_complete_list.length) NoMoreDataRef.current = false;
            if (page === 1) {
              setPastBooking(lab_complete_list);
              setTotalLength(lab_complete_list.length);
            } else {
              setPastBooking(prev => [...prev, ...lab_complete_list]);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  const HandleCancelAppointment = () => {
    if (!selectReason) {
      showToast({ title: t("Select Cancel Reason"), id: "error" });
      return;
    }
    if (selectReason === 4 && !otherReason) {
      showToast({ title: t("Enter Other Reason"), id: "error" });
      return;
    }
    if (Userid) {
      const Data = {
        id: Userid,
        lab_book_id: isCancelBox,
        reason_id: selectReason,
        reason: otherReason ? otherReason : ""
      };
      axios.post(`${ApiBaseUrl}/customer/cancel_lab_appointment`, Data)
        .then((res) => {
          // console.log(res);
          if (res.data.ResponseCode === 200) {
            showToast({ title: res.data.message, id: "success" });
            setIsCancelBox("");
            HandlefetchPandingData(1);
          }
        })
        .catch((error) => {
          console.error(error);
        });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const clientHeight = window.innerHeight;
      const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;
      if (isAtBottom && !hasReachedBottom.current && NoMoreDataRef.current) {
        hasReachedBottom.current = true;
        setPage(prev => prev + 1);
      } else if (!isAtBottom && hasReachedBottom.current) {
        hasReachedBottom.current = false;
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => { window.removeEventListener('scroll', handleScroll); };
  }, []);

  useEffect(() => {
    if (page === 1 && !NoMoreDataRef.current) return;
    if (selectBtnref.current === 0) {
      HandlefetchPandingData(page);
    } else {
      HandlefetchCompleteData(page);
    }
  }, [page]);

  const HandleNavigate = (id) => {
    Navigate("/package-details", { state: { id, isShow: selectBtnref.current } });
  };

  const AudioCallHandler = async (e, code, phone) => {
    e.stopPropagation();
    window.location.href = `tel:${code + phone}`;
  };

  const HandleSelectbtn = (index) => {
    selectBtnref.current = index;
    NoMoreDataRef.current = true;  
    setTotalLength(0);
    if (index === 0) {
      HandlefetchPandingData(1);
    } else {
      HandlefetchCompleteData(1);
    }
  };

  const getStatusStyle = (status) => {
    const map = {
      "1": { bg: "bg-amber-50 border-amber-100", text: "text-amber-600" },
      "2": { bg: "bg-orange-50 border-orange-100", text: "text-orange-600" },
      "3": { bg: "bg-cyan-50 border-cyan-100", text: "text-cyan-700" },
      "4": { bg: "bg-blue-50 border-blue-100", text: "text-blue-600" },
      "5": { bg: "bg-emerald-50 border-emerald-100", text: "text-emerald-600" },
      "7": { bg: "bg-rose-50 border-rose-100", text: "text-rose-600" },
    };
    return map[status] || { bg: "bg-slate-50 border-slate-100", text: "text-slate-600" };
  };

  const BookingCard = ({ item, isPending }) => {
    const { bg, text } = getStatusStyle(item.status);
    return (
      <div
        onClick={() => HandleNavigate(item.id)}
        className="bg-white rounded-3xl border border-slate-150 overflow-hidden shadow-sm hover:shadow-md hover:border-indigo-100 transition-all duration-300 cursor-pointer flex flex-col group"
      >
        {/* Lab Cover Image */}
        <div className="relative h-48 bg-slate-50 overflow-hidden">
          <ImageLoad
            src={ImgBaseUrl + item.lab_logo}
            CustomeStyle="w-full h-full object-cover transition-transform duration-500 group-hover:scale-103"
            alt="lab_logo"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/40 via-transparent to-transparent" />

          {/* Status Badge */}
          <div className={`absolute top-3 left-3 border text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-full shadow-sm ${bg} ${text}`}>
            {item.status_type}
          </div>

          {/* Appointment ID Badge */}
          <div className="absolute top-3 right-3 bg-white/90 backdrop-blur-sm border border-slate-150 text-slate-700 text-[10px] font-mono font-bold px-2.5 py-1 rounded-full shadow-sm">
            #{item.id}
          </div>
        </div>

        {/* Card Content */}
        <div className="p-5 flex flex-col flex-1 gap-3">
          <div>
            <span className="text-slate-400 text-[10px] font-bold uppercase tracking-wider block mb-0.5">{t("Appointment ID")}: {item.id}</span>
            <h3 className="font-bold text-slate-800 text-base line-clamp-1 group-hover:text-indigo-650 transition-colors">{item.name}</h3>
          </div>

          <div className="flex items-center justify-between">
            <div className="flex items-center gap-1.5 text-slate-400 text-xs font-semibold">
              <LuCalendar className="w-3.5 h-3.5 shrink-0" />
              <span>{item.date}</span>
            </div>
            <span className="font-black text-indigo-600 text-base">{currency}{item.tot_price}.00</span>
          </div>

          {/* Action Buttons */}
          <div className="flex items-center gap-2.5 pt-3 border-t border-slate-100 mt-auto">
            {isPending && item.status === "1" && (
              <button
                onClick={(e) => { e.stopPropagation(); setIsCancelBox(item.id); }}
                className="flex-1 py-2.5 border border-rose-200 hover:border-rose-300 bg-rose-50/50 hover:bg-rose-100 text-rose-600 font-bold text-xs rounded-full transition-all duration-200 active:scale-95"
              >
                {t("Cancel")}
              </button>
            )}
            <button
              onClick={(e) => AudioCallHandler(e, item.country_code, item.phone)}
              className="flex-1 py-2.5 border border-indigo-200 hover:border-indigo-300 bg-indigo-50/50 hover:bg-indigo-100 text-indigo-650 font-bold text-xs rounded-full transition-all duration-200 active:scale-95 flex items-center justify-center gap-1.5"
            >
              <LuPhoneCall className="w-3.5 h-3.5" />
              {t("Call")}
            </button>
          </div>
        </div>
      </div>
    );
  };

  const EmptyState = () => (
    <div className="col-span-full py-16 flex flex-col items-center justify-center text-center">
      <div className="w-24 h-24 bg-slate-50 border border-slate-150 rounded-full flex items-center justify-center mb-4 shadow-inner">
        <img src={emptyimg} className="w-16 h-16 object-contain opacity-75" alt="no booking" />
      </div>
      <h3 className="font-bold text-slate-800 text-lg mb-1">{t("No Booking placed !!")}</h3>
      <p className="text-slate-400 text-sm max-w-xs">{t("Currently You Don't Have Any Booking")}</p>
    </div>
  );

  return (
    <div className="booking-package-container w-full min-h-screen pb-[100px] content-wrapper px-4 md:px-6 max-w-7xl mx-auto">
      {loading ? (
        <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white z-[9999]" index={0} />
      ) : (
        <div className="flex flex-col">
          {/* Header Navigation */}
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 py-4 mb-6 border-b border-slate-100">
            <button
              onClick={() => window.history.back()}
              className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-2 hover:bg-slate-900 hover:text-white hover:border-slate-900 transition-all duration-200 shadow-sm"
            >
              <IoChevronBackOutline className="w-4 h-4" />
              <span className="font-medium text-sm">{t("Go Back")}</span>
            </button>

            <div className="flex items-center gap-2 text-sm text-slate-500">
              <span className="hover:text-indigo-650 font-medium transition-colors cursor-pointer" onClick={() => Navigate("/dashbord")}>{t("Dashboard")}</span>
              <LuChevronRight className="w-3.5 h-3.5" />
              <span className="font-semibold text-slate-800">{t("Lab Bookings")}</span>
            </div>
          </div>

          {/* Premium Tab Selector */}
          <div className="flex justify-center mb-8">
            <div className="bg-slate-100 p-1.5 rounded-full flex gap-2 shadow-sm border border-slate-150">
              <button
                onClick={() => HandleSelectbtn(0)}
                className={`px-6 py-2.5 rounded-full text-xs font-black tracking-wider uppercase transition-all duration-200 ${
                  selectBtnref.current === 0
                    ? "bg-white text-indigo-600 shadow-md"
                    : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {t("Pending")}
              </button>
              <button
                onClick={() => HandleSelectbtn(1)}
                className={`px-6 py-2.5 rounded-full text-xs font-black tracking-wider uppercase transition-all duration-200 ${
                  selectBtnref.current === 1
                    ? "bg-white text-indigo-600 shadow-md"
                    : "text-slate-500 hover:text-slate-700"
                }`}
              >
                {t("Complete")}
              </button>
            </div>
          </div>

          {/* Responsive Card Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {selectBtnref.current === 0 ? (
              currentBooking.length >= 1
                ? currentBooking.map((item, index) => (
                    <BookingCard key={index} item={item} isPending={true} />
                  ))
                : <EmptyState />
            ) : (
              pastBooking.length >= 1
                ? pastBooking.map((item, index) => (
                    <BookingCard key={index} item={item} isPending={false} />
                  ))
                : <EmptyState />
            )}
          </div>
        </div>
      )}

      {/* Cancellation Modal */}
      {isCancelBox && (
        <div
          onClick={() => setIsCancelBox("")}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div
            onClick={(e) => e.stopPropagation()}
            className="bg-white rounded-3xl p-6 shadow-2xl max-w-md w-full max-h-[80vh] scroll-container relative flex flex-col gap-5"
          >
            <button
              onClick={() => setIsCancelBox("")}
              className="absolute top-4 right-4 p-2 rounded-full text-slate-400 hover:text-slate-700 hover:bg-slate-100 transition-all duration-200"
            >
              <IoCloseSharp className="w-6 h-6" />
            </button>

            <div>
              <h2 className="font-bold text-slate-800 text-lg leading-snug">{t("Cancel Booking")}</h2>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mt-0.5">{t("Please select the reason for cancellation")}</p>
            </div>

            <div className="flex flex-col gap-3 mt-1">
              {cancelReasonList.map((item, index) => (
                <label
                  key={index}
                  onClick={() => setSelectReason(item.id)}
                  className={`flex items-center gap-3 p-3.5 border rounded-2xl cursor-pointer transition-all duration-150 ${
                    selectReason === item.id
                      ? "border-indigo-600 bg-indigo-50/30 text-indigo-900 font-bold"
                      : "border-slate-200 hover:border-slate-300 text-slate-700 font-medium"
                  }`}
                >
                  <div className="w-5 h-5 flex items-center justify-center shrink-0">
                    <div className={`w-5 h-5 rounded-full flex items-center justify-center border transition-colors ${
                      selectReason === item.id ? "border-indigo-600 bg-indigo-600" : "border-slate-300"
                    }`}>
                      <span className={`w-2 h-2 rounded-full bg-white duration-150 ${selectReason === item.id ? "scale-100" : "scale-0"}`}></span>
                    </div>
                  </div>
                  <span className="text-sm leading-tight">{item.title}</span>
                </label>
              ))}

              {selectReason === 4 && (
                <input
                  type="text"
                  onChange={(e) => setOtherReason(e.target.value)}
                  className="border border-slate-200 focus-within:outline-none focus:border-indigo-600 focus:ring-1 focus:ring-indigo-600 w-full py-3 px-4 rounded-2xl text-sm mt-1 shadow-sm"
                  placeholder={t("Enter reason details")}
                />
              )}
            </div>

            <div className="grid grid-cols-2 gap-4 mt-2">
              <button
                onClick={() => setIsCancelBox("")}
                className="py-3 bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98"
              >
                {t("Close")}
              </button>
              <button
                onClick={HandleCancelAppointment}
                className="py-3 bg-rose-600 hover:bg-rose-700 text-white font-bold rounded-2xl text-sm transition-all duration-150 active:scale-98 shadow-md shadow-rose-600/10"
              >
                {t("Confirm")}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Device Check Modal */}
      {deviceCheck && (
        <div
          onClick={() => setDeviceCheck(false)}
          className="flex bg-slate-900/60 backdrop-blur-sm h-full justify-center w-full fixed items-center left-0 top-0 z-[999] p-4 animate-fade-in"
        >
          <div onClick={(e) => e.stopPropagation()} className="bg-white rounded-3xl p-6 shadow-2xl max-w-sm w-full text-center">
            <div className="w-12 h-12 rounded-full bg-amber-50 text-amber-600 flex items-center justify-center mx-auto mb-4 border border-amber-100">
              <LuPhoneCall className="w-6 h-6" />
            </div>
            <h2 className="font-bold text-slate-800 text-lg mb-2">{t("Audio Input Required")}</h2>
            <p className="text-slate-500 text-sm leading-relaxed">
              {t("Required for voice and video calls. Make sure your audio device (headset, speakers, or microphone) is connected and working.")}
            </p>
            <button
              onClick={() => setDeviceCheck(false)}
              className="mt-5 w-full py-2.5 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-xl text-sm transition-all duration-150 active:scale-98"
            >
              {t("Got It")}
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default BookingPackage;
/* jshint ignore:end */